<!-- Translated: yes -->
<template>
  <div>
    <div class="banner">
      <OnSiteFooter style="z-index:1000000;" v-if="$store.state.isOnSite" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import OnSiteFooter from '@/components/components/OnSiteFooter';

export default {
  data() {
    return {
      intervalRef: null,
      resetSecondsLeft: 0,
    };
  },
  components: {
    OnSiteFooter,
  },
  computed: {
    ...mapGetters([
      'guidedRentals',
    ]),
  },
  created() {
    window.addEventListener('mousemove', this.resetTimer);
    window.addEventListener('click', this.resetTimer);
    window.addEventListener('keyup', this.resetTimer);
  },
  destroyed() {
    clearInterval(this.intervalRef);
  },
  mounted() {
    this.setOnSite();
    this.clearCart();

    const refresh = parseInt(this.$route.query.refresh, 10);

    if (this.$route.query.key) {
      this.$store.state.onsite_key = this.$route.query.key;
    }

    if (this.$route.query.refresh && refresh === 1) {
      const route = {
        name: this.$route.name,
        query: Object.assign({}, this.$route.query),
      };
      route.query.refresh = 0;
      this.$router.replace(route);
      window.location.reload();
      return;
    }

    this.$store.state.isOnWhichSite = this.$route.query.site;
    if (!this.$route.query.site) {
      alert('Lägg på en site med ?site=X'); //eslint-disable-line
      return;
    }

    this.resetTimer();

    this.$nextTick(() => {
      this.intervalRef = setInterval(() => {
        this.resetSecondsLeft -= 1;
        if (this.resetSecondsLeft < 0) {
          window.location.reload();
        }
      }, 1000);

      this.openModal(['SkiRentalPickDate', {
        type: 'without-delivery',
      }]);
    });
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal',
      'setOnSite',
      'clearCart',
    ]),
    resetTimer() {
      this.resetSecondsLeft = (5 * 60);
    },
    goBack() {
      this.$router.replace({ name: 'on site' });
    },
  },
};
</script>

<style lang="stylus">
body
  background-color white
</style>

<style scoped lang="stylus">
@import '~@/global.styl'

.footer
  position: fixed;
  bottom: 0


.banner
  height 100vh
  background-size cover
  background-image url(https://static.booking.branasgruppen.se/static/img/toppbild-utrustning.jpg)
  background-position center
  position relative
  padding 0

  h1
    position absolute
    bottom 0
    left calc(50% - 300px)
    width 600px
    max-width 100%
    padding 15px 5px
    margin-bottom 0
    background-color rgba(255, 255, 255, 0.92)
    united-heavy()
    uppercase()
    centered()
    font-size size-font-headline
    color brick

.ingress
  width 674px
  font-size 17px
  font-weight bold
  margin 25px auto
  text-align center

.offer-wrapper
  display flex
  justify-content space-between
  max-width 980px
  margin 0 auto

  .offer-box
    width 48%
    background-color #ffffff
    box-shadow 0 0 17px 0 rgba(0, 0, 0, 0.13)
    padding 15px 17px
    cursor pointer
    .content
      padding 8px 15px

    ul
      ul-with-checkboxes()

    .image
      width 100%
      height 240px
      background-size cover
      flex-wrap wrap
      centered()
      padding-top 35px
      h2
        united-heavy()
        uppercase()
        centered()
        font-size size-font-headline
        color white
        width 100%
        padding-top 5px
      &.red
        background-image linear-gradient(rgba(190, 36, 28, 0.89), rgba(190, 36, 28, 0.89)), url(https://static.booking.branasgruppen.se/static/img/utkorning-kort-bg.jpg)
      &.blue
        background-image linear-gradient(rgba(0, 85, 128, 0.95), rgba(0, 85, 128, 0.95)), url(https://static.booking.branasgruppen.se/static/img/hamta-sjalv-kort-bg.jpg)
        h2
          padding-top 20px

    p
      font-size size-font-4
      font-weight 300
      line-height 1.3
      color #262626
      margin-top 15px
      margin-bottom 15px

    ul
      li
        font-size size-font-2
        margin-bottom 12px

    button
      margin-top space-2

.info
  max-width 980px
  margin 60px auto 35px auto
  h2
    united-heavy()
    uppercase()
    centered()
    font-size size-font-headline
    color #262626
    font-size size-font-headline-small
    margin-top 45px
    margin-bottom 20px
  p
    font-size size-font-3
    max-width 656px
    margin 0 auto
    margin-bottom 1em
</style>



// WEBPACK FOOTER //
// SkiRentalOnSitePage.vue?76c66851